import { translateItem } from './hooks';

const JOINER = ', ';

export const translateEnumeration = async (list: string[], options?: { cutoff?: number }) => {
    let emptyCount = 0;
    list = list
        .map((i) => i.trim())
        .filter((i) => {
            if (!i.length) emptyCount++;
            return !!i.length;
        });

    if (!list.length) return '';
    if (list.length === 1) return list[0];

    const and = (await translateItem('And')).trim().toLocaleLowerCase();

    if (emptyCount || (options?.cutoff && list.length > options.cutoff)) {
        const more = (await translateItem('More')).trim().toLocaleLowerCase();
        if (!and.length || !more.length) return list.join(JOINER);

        const cut = list.splice(options?.cutoff ?? 0);
        const remainingLength = cut.length + emptyCount;

        return `${list.join(JOINER).trim()} ${and} ${remainingLength} ${more}`;
    } else {
        if (!and.length) return list.join(JOINER);

        const [lastInList] = list.splice(list.length - 1, 1);
        return `${list.join(JOINER).trim()} ${and} ${lastInList.trim()}`;
    }
};
